/* eslint-disable no-invalid-this */

import ApiService, { USERS_API_CONTEXT, USERS_API_HOST } from './ApiService';

/**
 * @override
 */
class DistributorsService extends ApiService {
    /**
     * constructor
     */
    constructor() {
        super({ baseURL: USERS_API_HOST });
    }

    getDistributors = (sort, config) => {
        if (sort.trim() !== '') {
            return this.getList(`${USERS_API_CONTEXT}/distributors?$orderby=${sort}`, config);
        } else {
            return this.getList(`${USERS_API_CONTEXT}/distributors`, config);
        }
    };
    getDistributorByUUId = (uuid, config) => {
        return this.get(`${USERS_API_CONTEXT}/distributors/${uuid}`, config);
    }
    getPagination = (url, config) => this.get(`${url}`, config);
    /**
     * Actualizamos la información del distributor
     * @override
     */
    update = (uuid, dist) => {
        return this.put(`${USERS_API_CONTEXT}/distributors/${uuid}`, dist);
    };
    /**
     * @override
     */
    create = dist => {
        return this.post(`${USERS_API_CONTEXT}/distributors`, dist);
    };

    /**
     * @override
     */
    download = (sort, config, headers) => {
        if (sort.trim() !== '') {
            return this.getDownload(`${USERS_API_CONTEXT}/distributors/download?$orderby=${sort}`, config, { headers });
        } else {
            return this.getDownload(`${USERS_API_CONTEXT}/distributors/download`, config, { headers });
        }
    };

    /**
     * Delete Distributors
     * @param {String} uuid Distributors id
     * @return {Object} Response of delete operation
     */
    deleteDistributorByUUId = uuid => {
        return this.delete(`${USERS_API_CONTEXT}/distributors/${uuid}`, {});
    };

}

const distributorsService = new DistributorsService();

export default distributorsService;

